import { CircleCheck, Clock } from 'lucide-react'

import { Badge } from '@/components/ui/badge'

/** green when a super (or supplier-wide verification) has signed off, amber
 * while it still sits in the review queue. shown on profiles and the
 * company's own Certificates page.
 */
export function CertStatusBadge({ verified }: { verified: boolean }) {
  if (verified) {
    return (
      <Badge className='gap-1 border-transparent bg-emerald-100 text-emerald-900 dark:bg-emerald-950 dark:text-emerald-200 [&>svg]:size-3'>
        <CircleCheck />
        Verified
      </Badge>
    )
  }
  return (
    <Badge className='gap-1 border-transparent bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200 [&>svg]:size-3'>
      <Clock />
      Pending review
    </Badge>
  )
}
